var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.529,
    height: 23.529,
    viewBox: "0 0 23.529 23.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22",
    "data-name": "Layer 22",
    transform: "translate(-2.001 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M17.966,10.79,14.95,13.765l3.017,2.975a.853.853,0,1,1-1.185,1.227l-3.017-3.017L10.79,17.966a.838.838,0,0,1-1.185-1.185l2.975-3.017L9.605,10.79A.84.84,0,0,1,10.79,9.6l2.975,2.975L16.74,9.6a.853.853,0,0,1,1.227,1.185Zm4.118,11.294a11.765,11.765,0,1,1,0-16.639,11.765,11.765,0,0,1,0,16.639ZM20.9,6.63a10.084,10.084,0,1,0,2.966,7.143A10.084,10.084,0,0,0,20.9,6.63Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cdf42d18c7df7454b1a8bcae86df8db3.svg";
export { ForwardRef as ReactComponent };